export default __webpack_public_path__ + "static/media/trust.36715340.svg";